import type { Plugin } from 'vue'
import { useToast } from '@/composables/toast'
import { getError } from '@/utils/error'

export default {
  install(app) {
    const { error: showError } = useToast()

    app.config.errorHandler = (err) => {
      console.error(err)
      showError(getError(err).message)
    }

    window.addEventListener('unhandledrejection', (event) => {
      const error = event.reason
      console.error(error)
      showError(getError(error).message)
    })
  },
} as Plugin
